// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// import { initializeApp } from "firebase/app";
// import { getRemoteConfig, getValue, fetchAndActivate } from "firebase/remote-config";
import { decryptEnv, getDataFromLocal, getCookie } from "../src/helpers";
const firebaseConfig = {
    apiKey: "AIzaSyCdvUNORUZu4PfiQVKGjc0dayhv7lcvHvk",
    authDomain: "paisa-mf.firebaseapp.com",
    databaseURL: "https://paisa-mf.firebaseio.com",
    projectId: "paisa-mf",
    storageBucket: "paisa-mf.firebasestorage.app",
    messagingSenderId: "945111842441",
    appId: "1:945111842441:web:4477d667cabcf81e2b5058",
    measurementId: "G-JE6TT47SCX"
};
let firstComes = true;
const remoteConfig = (() => {
    if (!window.firebase) {
        console.error("Firebase is not available");
        return null;
    }
    try {
        const app = window.firebase.initializeApp(firebaseConfig);
        const config = window.firebase.getRemoteConfig(app);
        config.settings.minimumFetchIntervalMillis = 300000; // Increased to 8 hours
        return config;
    }
    catch (err) {
        console.error("Firebase config failed Error", err);
        return null;
    }
})();
export const InternalCWAUser = async () => {
    try {
        if (remoteConfig) {
            await window.firebase.fetchAndActivate(remoteConfig);
            const stringValue = window.firebase.getValue(remoteConfig, "AutoSave_Internaluser").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            if (remoteConfigData) {
                let cwa2 = false;
                const decryptedClientList = decryptEnv(remoteConfigData.accesslist);
                const clientCode = getDataFromLocal("ClientCode").toString();
                cwa2 = decryptedClientList.includes(clientCode);
                sessionStorage.setItem("__cInternal", cwa2.toString());
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
export const InternalLogglyUser = async () => {
    try {
        if (remoteConfig) {
            await window.firebase.fetchAndActivate(remoteConfig);
            const stringValue = window.firebase.getValue(remoteConfig, "Loggly_Internaluser").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            if (remoteConfigData) {
                let cwa2 = false;
                const decryptedClientList = decryptEnv(remoteConfigData.accesslist);
                const clientCode = getDataFromLocal("ClientCode").toString();
                cwa2 = decryptedClientList.includes(clientCode);
                sessionStorage.setItem("__lInternal", cwa2.toString());
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
export const getLoginUrL = async () => {
    try {
        if (remoteConfig) {
            await window.firebase.fetchAndActivate(remoteConfig);
            const stringValue = window.firebase.getValue(remoteConfig, "Login_Redirection_URL").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            if (remoteConfigData) {
                return remoteConfigData.LoginRedirectionURL;
            }
        }
    }
    catch (error) {
        console.error(error);
        return "https://login.5paisa.com";
    }
};
export const initializeFireBaseAppAndRemoteConfig = () => {
    if (!remoteConfig) {
        window.location.replace("https://login.5paisa.com/?returnurl=" + window.location.href);
        return;
    }
    window.firebase
        .fetchAndActivate(remoteConfig)
        .then(() => {
        const frontend_crossSell_keys = window.firebase
            .getValue(remoteConfig, "frontend_crossSell_keys")
            .asString();
        try {
            const remoteConfigData = JSON.parse(frontend_crossSell_keys);
            window.location.replace(`${remoteConfigData.LoginRedirectionURL}?returnurl=${window.location.href}`);
        }
        catch (error) {
            console.error("Error while parsing and getting key values");
            window.location.replace("https://login.5paisa.com/?returnurl=" + window.location.href);
        }
    })
        .catch((err) => {
        console.error(err, "Fetch and Activate failed");
        window.location.replace("https://login.5paisa.com/?returnurl=" + window.location.href);
    });
};
export const tradingTimeFirebaseConfig = async () => {
    if (!remoteConfig)
        return null;
    try {
        if (firstComes) {
            await window.firebase.fetchAndActivate(remoteConfig);
            firstComes = false;
        }
        const cachedTradingTime = window.firebase.getValue(remoteConfig, "tv_chart_configuration").asString();
        if (cachedTradingTime) {
            return JSON.parse(cachedTradingTime); // Use cached value if available
        }
        if (remoteConfig.lastFetchStatus !== "success") {
            await window.firebase.fetchAndActivate(remoteConfig);
        }
        const updatedTradingTime = window.firebase.getValue(remoteConfig, "tv_chart_configuration").asString();
        return JSON.parse(updatedTradingTime);
    }
    catch (e) {
        console.error("Error fetching trading time configuration:", e);
        return null;
    }
};
const getLastCharCookie = () => {
    let cookie = getCookie("5paisacookie") || " ";
    return cookie ? cookie[cookie.length - 1] : " ";
};
export const IsOmnenestUser = async () => {
    try {
        if (remoteConfig) {
            await window.firebase.fetchAndActivate(remoteConfig);
            const stringValue = window.firebase.getValue(remoteConfig, "omnenest_enable_servers").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            if (remoteConfigData) {
                const decryptedClientList = remoteConfigData.omnenestEnabledServers;
                const lastCharCookie = getLastCharCookie();
                const omnenestUser = decryptedClientList.includes(lastCharCookie);
                // sessionStorage.setItem("__oInternal", omnenestUser.toString());
                return omnenestUser;
            }
        }
    }
    catch (error) {
        console.error(error);
    }
    return false;
};
export const getAlgoSpaceConfig = async () => {
    try {
        if (remoteConfig) {
            await window.firebase.fetchAndActivate(remoteConfig);
            const stringValue = window.firebase.getValue(remoteConfig, "ttweb_algospaceVisibility").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            return remoteConfigData;
        }
    }
    catch (error) {
        console.error("Error fetching algo space config:", error);
        return false;
    }
};
